import { setupDependencies, initDependencies } from './dependencies';
import { start } from './start';

setupDependencies();
initDependencies();

start();

// oxlint-disable-next-line typescript/no-explicit-any
if ((module as any).hot) {
  // oxlint-disable-next-line typescript/no-explicit-any
  (module as any).hot.accept();
}
